import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "onboarding" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "onboarding_bg" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "top bg_violet" }),
  /*#__PURE__*/_createElementVNode("div", { class: "bottom bg_black" })
], -1)
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = { class: "sideContainer" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "sideContainer" }, null, -1)
const _hoisted_7 = { class: "bg_grey" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "squareButton bg_black",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
          })
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_localized_text, {
          type: "h1",
          localizedKey: "app_Benvenuto!",
          text: "Benvenuto!",
          class: "text-center"
        }),
        _createElementVNode("form", {
          class: "mt-5",
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
        }, [
          _createVNode(_component_form_field, {
            type: "email",
            modelValue: _ctx.model.username,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.username) = $event)),
            placeholderKey: "backoffice_Mail",
            placeholderValue: "Mail"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_form_field, {
            class: "pb-3",
            type: "password",
            modelValue: _ctx.model.password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.password) = $event)),
            placeholderKey: "backoffice_Password",
            placeholderValue: "Password"
          }, null, 8, ["modelValue"]),
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary w-100 mt-4",
            disabled: _ctx.disabled
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "app_Accedi",
              text: "Accedi"
            })
          ], 8, _hoisted_8)
        ], 32)
      ])
    ])
  ]))
}